import { render, staticRenderFns } from "./dashboard-sando.vue?vue&type=template&id=125d6a38"
import script from "./dashboard-sando.vue?vue&type=script&lang=js"
export * from "./dashboard-sando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports